import type { OrderRefundStatus, OrderStatus } from '../types'

export const orderStatusColors: Record<string, string> = {
  PENDING: 'gold',
  PAID: 'green',
  SETTLED: 'blue',
  REFUNDED: 'orange',
  DISPUTED: 'red',
  CLOSED: 'default',
  FAILED: 'red',
}

export const orderStatusLabels: Record<string, string> = {
  PENDING: '待支付',
  PAID: '已支付',
  SETTLED: '已結算',
  REFUNDED: '已退款',
  DISPUTED: '爭議中',
  CLOSED: '已關閉',
  FAILED: '支付失敗',
}

export function shouldShowOrderFees(status: OrderStatus): boolean {
  return status !== 'CLOSED' && status !== 'FAILED'
}

export function orderDisplayStatus(
  status: OrderStatus,
  refundStatus?: OrderRefundStatus,
): OrderStatus {
  return refundStatus === 'FULL' ? 'REFUNDED' : status
}
